import { useMemo } from "react";
import { useIntl } from "react-intl";

export function useString(id: string) {
    const intl = useIntl();
    const translatedStr = useMemo(() => intl.formatMessage({ id }), [id, intl]);
    return translatedStr;
}
